import { useEffect } from 'react';

import { type Toast } from '../toast';
import { toast } from '../utils/toast';

/**
 * Shows a toast whenever `options` changes to a non-null value, on the
 * next tick after render. Feed it the toast from {@link getToast} to
 * surface server-flashed messages. It needs an {@link EpicToaster}
 * mounted in the tree. For imperative use, call {@link toast} directly.
 *
 * @param options Toast to show, or null/undefined to show nothing.
 */
export function useToast(options?: Toast | null) {
  useEffect(() => {
    if (options) {
      setTimeout(() => {
        toast(options);
      }, 0);
    }
  }, [options]);
}
